import React, { useContext } from "react";
// import { AnimatePresence } from "framer-motion";
import NoSSRAnimatePresence from "components/NoSSRAnimatePresence";

import FadeInOut from "@components/Animations/FadeInOut";
import ConditionalWrapper from "@components/Reusables/ConditionalWrapper";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors, duration } from "utils/styles";
import { Logo, LogoSmall } from "components/Logo";
import { CartIcon } from "components/CartComponents";

import { HeaderContext, UserContext } from "contexts/";
import { MenuBtn, UserDropdown } from "./";
import ScheduleAdvisingSession from "components/CTA/ScheduleAdvisingSession";
import JoinMembership from "components/CTA/JoinMembership";
import RenewMembership from "components/CTA/RenewMembership";
import useMembershipStatus from "hooks/useMembershipStatus";

import MobileNavigation from "./Navigation/MobileNavigation";
export default function MobileHeader(props = {}) {
	const { slimNav, hasSubNav, hasRegistrationNav } = props;

	const { isMobileNavOpen } = useContext(HeaderContext);
	const { userData } = useContext(UserContext);
	const membershipStatus = useMembershipStatus();
	const { requiresWebsiteBanner, membershipExpireingMessage } = membershipStatus;

	return (
		<div className="mobileHeaderWrapper d-block d-lg-none">
			<header className={`d-block d-lg-none    mobileHeader ${slimNav ? "myShow" : "py-2"} `}>
				{!hasRegistrationNav && (
					<ConditionalWrapper
						condition={hasSubNav}
						wrapper={(children) => (
							<FadeInOut
								initial={slimNav ? "hidden" : "visible"}
								animate={slimNav ? "hidden" : "visible"}
								myKey={"hasSubNav"}
								// withHeight={false}
								className={slimNav ? "" : "relative z-index-10"} //very important for z-index control
							>
								{children}
							</FadeInOut>
						)}
					>
						<Row className="align-items-center px-sm-0 px-2 g-0 py-1 ">
							{/* Logo col */}
							<Col
								className="overflowHidden "
								xs={slimNav ? 3 : 4}
								//   sm={slimNav ? 3 : 3}
								md={slimNav ? 2 : 3}
							>
								<NoSSRAnimatePresence>
									{!slimNav && (
										<FadeInOut animate={slimNav ? "hidden" : "visible"} myKey={"largeLogo"}>
											<Logo />
										</FadeInOut>
									)}
									{slimNav && (
										<FadeInOut animate={!slimNav ? "hidden" : "visible"} myKey={"smallLogo"}>
											<LogoSmall />
										</FadeInOut>
									)}
								</NoSSRAnimatePresence>{" "}
							</Col>
							{/* Nav Links */}
							<Col
								className=""
								xs={slimNav ? 9 : 8}
								// sm={slimNav ? 9 : 9}
								md={slimNav ? 10 : 9}
							>
								<Row className="align-items-end g-0  ">
									<Col className=" justify-content-end pe-3 d-flex " md={"12"}>
										<Row className=" align-items-end">
											<Col className="d-flex justify-content-end pe-4" xs={"6"}>
												{/* <span className="   "> */}
												<CartIcon />
												{/* </span> */}
											</Col>
											<Col className=" d-flex justify-content-end " xs={6}>
												<MenuBtn />
											</Col>
										</Row>
									</Col>
									<Col className="mt-2  justify-content-end d-flex " xs={true} md={12}>
										<UserDropdown />
									</Col>
								</Row>
							</Col>
						</Row>
					</ConditionalWrapper>
				)}
				{((hasSubNav && !isMobileNavOpen) || (slimNav && hasSubNav)) && (
					<Row className="g-0">{hasSubNav.Mobile()}</Row>
				)}
				{isMobileNavOpen && <MobileNavigation className={` pt-1 ps-4 `} />}
			</header>

			{isMobileNavOpen && (
				<div className="callToActionContainer py-4 ">
					{requiresWebsiteBanner ? (
						<RenewMembership />
					) : !userData || !userData?.isMember ? (
						<JoinMembership />
					) : (
						userData?.isMember && !requiresWebsiteBanner && <ScheduleAdvisingSession />
					)}
				</div>
			)}
			<style jsx>{`
				@media screen and (max-width: 991px) {
					.mobileHeader {
						padding: 0 3em;
					}
				}
				@media screen and (max-width: 650px) {
					.mobileHeader {
						padding: 0 1em;
					}
				}
				@media screen and (max-width: 550px) {
					.mobileHeader {
						padding: 0 0em;
					}
				}
				.mobileHeaderWrapper {
					min-height: ${isMobileNavOpen ? "100%" : "auto"};
					background: ${colors.white};
					transition: background ${duration.navFade};
					top: 0;
					right: 0;
					left: 0;
				}
				.mobileHeader {
					transition: all 0.2s ease;
				}

				.myDashboard {
					font-size: 14px;
					font-family: "Open Sans";
					line-height: 21px;
				}

				@media screen and (max-width: 991px) {
					.callToActionContainer {
						padding: 0 4.5em;
						margin-bottom: 3em;
					}
				}
				@media screen and (max-width: 650px) {
					.callToActionContainer {
						padding: 0 2.5em;
					}
				}
				@media screen and (max-width: 550px) {
					.callToActionContainer {
						padding: 0 1em;
					}
				}

				.callToActionContainer {
					border-top: 1px solid #707070;
					align-self: end;
					width: 100%;
				}
			`}</style>
			<style jsx global>{`
				/* helps keep the mobile nav header from moving  */
				body {
					overflow-y: ${isMobileNavOpen ? "scroll" : "auto"};
				}
				main {
					opacity: ${isMobileNavOpen ? "1" : "1"};
					transition: opacity ${duration.navFade};
				}
			`}</style>
		</div>
	);
}
